import authAxios from '@services/authAxios';

const fetchStatus = async () => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/status-upload/list`,
    });

    return data?.data?.page_data;
};

export default fetchStatus;
